// extracted by mini-css-extract-plugin
export default {"scroll-box":"ScrollBox_scroll-box_S3BN2"};